export default __webpack_public_path__ + "static/media/FSM_logo.69f5e65b.png";